var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row q-gutter-x-sm justify-center q-py-sm bg-white full-width bdr-t-grey-4"},[_c('SAIBtn',{staticClass:"all-pointer-events",attrs:{"no-caps":true,"size":"16px","disable":_vm.disable,"loading":_vm.loadingAccepting,"padding":"11px xl","label":"I’m ready to accept"},on:{"click":function($event){return _vm.$emit('accept')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }